import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import SocketClient from 'store/reducers-common/Socket/socketClient.ts'

type State = {
  connection: string[]
  isSignedIn: boolean
  query: null | string
}

const initialState: State = {
  connection: [],
  isSignedIn: false,
  query: null,
}

export const sliceSocket = createSlice({
  initialState,
  name: 'socket',
  reducers: {
    connect: (state, { payload }: PayloadAction<{ query: string; socket: SocketClient }>) => {
      state.isSignedIn = true
      state.query = payload.query
      if (!state.connection.includes(payload.query)) {
        state.connection.push(payload.query)
      }
    },
    disconnect: (state, { payload }: PayloadAction<{ query: string; socket: SocketClient }>) => {
      if (payload.socket?.query === state.query) {
        state.isSignedIn = false
        state.query = null
      }
      state.connection = state.connection.filter((item) => item !== payload.query)
    },
  },
})

export const { connect, disconnect } = sliceSocket.actions
